// frontend/src/components/pages/LoginPage.js
import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/login`,
        new URLSearchParams(formData),
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      );
      const token = res.data.access_token;
      // 사용자 정보 가져와서 로그인 처리
      const userRes = await axios.get(
        `${process.env.REACT_APP_API_URL}/users/me`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      login(token, userRes.data);
      navigate('/');
    } catch (err) {
      const status = err.response?.status;
      const detail = err.response?.data?.detail;
      // HTTP 상태코드와 detail 메시지에 따라 alert 띄우기
      if (status === 401) {
        alert('잘못된 아이디 또는 비밀번호입니다.');
      } else if (status === 403 && typeof detail === 'string') {
        alert(`${detail}`);
      } else if (status === 403 && Array.isArray(detail)) {
        // Pydantic Validation 에러 등 배열 형태
        alert(detail.map((d) => d.msg).join(' | '));
      } else {
        alert('로그인에 실패했습니다. 다시 시도해 주세요.');
      }
      console.error(err);
    }
  };

  return (
    <div className="max-w-[400px] mx-auto my-8">
      <h2 className="mb-4 text-2xl font-semibold text-neutral-900">로그인</h2>

      {error && (
        <p className="mb-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
          {error}
        </p>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="mb-4">
          <label className="mb-1 block text-sm font-medium text-neutral-700">
            아이디
          </label>
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={handleChange}
            required
            className="block w-full rounded-lg border border-neutral-300 px-3 py-2
                     text-neutral-900 placeholder-neutral-400
                     focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
          />
        </div>

        <div className="mb-4">
          <label className="mb-1 block text-sm font-medium text-neutral-700">
            비밀번호
          </label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            className="block w-full rounded-lg border border-neutral-300 px-3 py-2
                     text-neutral-900 placeholder-neutral-400
                     focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
          />
        </div>

        <button
          type="submit"
          className="inline-flex items-center justify-center rounded-lg
                   bg-sky-600 px-4 py-2 text-white font-medium
                   hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-500"
        >
          로그인
        </button>
      </form>
    </div>
  );
}
